import { render } from "./PayyoTerminalRegistrationModal.vue?vue&type=template&id=16fa12cc&scoped=true"
import script from "./PayyoTerminalRegistrationModal.vue?vue&type=script&lang=js"
export * from "./PayyoTerminalRegistrationModal.vue?vue&type=script&lang=js"

import "./PayyoTerminalRegistrationModal.vue?vue&type=style&index=0&id=16fa12cc&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fa12cc"]])

export default __exports__